'use strict';

angular.module('cloudBillingLegacyFrontend').controller('CspUpdateM1AccountCtrlMixin', function($scope, $modal) {

  $scope.openCspUpdateM1AccountDialog = function(exitingAccountModel) {

    var modalInstance = $modal.open({
      templateUrl: "views/csp/modals/modal_ac_csp_update_m1_account.html",
      controller: 'ModalCspUpdateM1AccountCtrl',
      resolve: {
        AccountModel: function() {
          return exitingAccountModel ? exitingAccountModel : {};
        }
      }
    });

    // returns a promise
    return modalInstance.result;
  };
});
